import React from 'react';
import { BaseActions } from './components/BaseActions/BaseActions';
import { FidelityActions } from './components/FidelityActions/FidelityActions';
import { useDocumentVaultContext } from '../../context/useDocumentVaultContext';
import { AuthenticationAuthorityDTO } from '../../DocumentVault.meta';

export const BrowserHeaderActions = () => {
  const { selectedEntity } = useDocumentVaultContext();

  return (
    <>
      <BaseActions />
      {selectedEntity?.authenticationAuthority === AuthenticationAuthorityDTO.FidelityDocuments && (
        <FidelityActions />
      )}
    </>
  );
};
